import { useState } from "react";
import { useAdminAuthContext  } from "./useAdminAuthContext";
import API_URL from '../../api/API'
import { Link,useNavigate } from "react-router-dom";



export const useAdminLogin = () =>{

    const navigate = useNavigate();

    const [error,setError] = useState(null);
    const [isLoading,setIsLoading] = useState(null);
    const {dispatch} = useAdminAuthContext();

    const adminLogin = async (email,password) => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await fetch(API_URL.POST_ADMIN_LOGIN,{
                method: 'POST',
                headers: {'Content-Type' : 'application/json'},
                body: JSON.stringify({email,password})
            });
    
            const json = await response.json();
    
            if(!response.ok){
                setIsLoading(false);
                setError(json.error);
            }
    
            if(response.ok){
                //save the user to the local storage
                localStorage.setItem('admin',JSON.stringify(json));
                dispatch({type:'ADMIN_LOGIN',payload:json});
                setIsLoading(false);
                navigate('/administrator/dashboard');

            }
        } catch (error) {
            setError(error.message);
            setIsLoading(false);
        }

        
    }

    return {adminLogin, isLoading, error};
}